import React from 'react'

import {Input} from 'forms'

const inRange = (group, field, [from, to], value) => {
   if (value >= from && value <= to) {
      return true
   } else {
      return {
         error: 'field `' + group + '.' + field + '` out of range (' + from + ' - ' + to + ')'
      }
   }
}

export const Range = ({group, field, spec}) => (
   <div>
      <Input
         param={group + '.' + field}
         label={spec.label || group + '.' + field}
         validate={value => inRange(group, field, spec.range || [], value)}
      />
   </div>
)

Range.propTypes = {
   group: React.PropTypes.string.isRequired,
   field: React.PropTypes.string.isRequired,
   spec:  React.PropTypes.object.isRequired,
   value: React.PropTypes.any
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/device/configuration/fields/Range.jsx